// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".style_root__1PWS- {\n  width: 100%;\n  height: 106px;\n  padding-top: 10px; }\n  .style_root__1PWS- .style_title__3qDUl {\n    font-weight: bold;\n    margin-bottom: 20px; }\n", ""]);
// Exports
exports.locals = {
	"root": "style_root__1PWS-",
	"title": "style_title__3qDUl"
};
module.exports = exports;
